import { getQIMEI36 } from './C4PV';
import querystring from 'query-string';

let contenturl = '';
// 设置大同公参及私参，由于在主流初始化函数中调用，所以这里不能使用await，而是使用异步设置参数
// 调用位置为主要的三个路径entry/client.js中
async function setPublicAndPrivateParams(contenturlLink = '') {
  // 给大同公参设置qimei36
  getQIMEI36().then((qimei36) => {
    if (window.UniversalReport) {
      console.log(1233333);
      window.UniversalReport.setPublicParams({ qimei36 });
    }
  });
  contenturl = contenturlLink;
}

export function setCommonParams(params = {}) {
  // 增加一些共同参数
  const contenturlParams = querystring.parse(contenturl);
  const { data_type: dataType = '', url = '', strategy = '', starttype = '' } = contenturlParams;
  const urlParams = querystring.parse(url);
  const { rowkey = '' } = urlParams;
  const modifiedParams = { data_src: dataType, rowkey, strategy_id: strategy, starttype, ...params };
  return modifiedParams;
}

function getParamsStr(params = {}) {
  const modifiedParams = setCommonParams(params);

  const keys = Object.keys(modifiedParams);
  if (keys.length <= 0) {
    return;
  }
  return keys.reduce((preStr, curKey, i) => {
    const curClip = `${curKey}=${modifiedParams[curKey]}`;
    return `${preStr}${i === 1 ? `=${modifiedParams[preStr]}` : ''}&${curClip}`;
  });
}
function getReportProps(eid, params, impIgnore) {
  // 在这里使用异步的话会影响埋点上报！！请不要在这里异步获取上报参数
  const paramsStr = getParamsStr(params);
  if (impIgnore) {
    return {
      'dt-eid': eid,
      'dt-params': paramsStr,
      'dt-imp-ignore': 'true',
    };
  }
  return {
    'dt-eid': eid,
    'dt-params': paramsStr,
    'dt-imp-once': 'true',
  };
}

// 图搜视频上报
function imageVideoCard(cid, parentCid, busiType) {
  return getReportProps('card', {
    cid,
    parent_cid: parentCid,
    busi_type: busiType,
    area: 'news_pic_search',
  });
}

// 作者热文卡片曝光&点击
function authorHotContentCard(cid, parentCid, ch, innerCh, busiType, stratege, dataSrc) {
  return getReportProps(
    'card',
    {
      cid, // docId
      parent_cid: parentCid, // 宿主docId
      ch, // 外部渠道号
      innerch: innerCh, // 内部渠道号
      busi_type: busiType, // 业务类型 图文picture_text/短视频short_video
      stratege, // 策略ID
      data_src: dataSrc, // 推荐来源（1：机器推荐，2：人工运营 ）*
      area: 'follow_hot_reccom', // 区域
    },
    false,
  );
}

// 编号11相关区域文章
function card(parentCid, cid) {
  return getReportProps('card', {
    cid,
    area: 'relevant_contentid',
    content_type: 5,
    parent_cid: parentCid,
    actionid: 'click_comment',
    click_type: 'single',
  });
}

// 编号5点赞/取消点赞
function likeButton(cid, isActive) {
  return getReportProps(
    'like_button',
    {
      cid,
      actionid: isActive ? 'click_done_like' : 'click_like',
      click_type: 'single',
    },
    true,
  );
}
// 编号13点击进行微信渠道分享 ，分享到微信好友；不同用户可能不同的分享可能性
function wxShareButton(cid) {
  return getReportProps(
    'wx_share_button',
    {
      cid,
      actionid: 'click_share',
      click_type: 'single',
      area: 'bottom',
      busi_type: 'picture_text',
      value: '微信',
    },
    false,
  );
}
// 编号12点击弹出负反馈弹窗可以进行具体选择
function feedbackButton(cid) {
  return getReportProps(
    'feedback_button',
    {
      cid,
      actionid: 'click_feedback',
      click_type: 'single',
    },
    true,
  );
}
// 编号4点击之后关注或取消关注
function followButton(cid, isActive, puin, area = 'follow_head_pic_bt') {
  return getReportProps(
    'follow_button',
    {
      cid,
      actionid: isActive ? 'cancel_follow' : 'click_follow',
      click_type: 'single',
      puin,
      area,
    },
    true,
  );
}
// 编号3点击之后进入自媒体个人主页
function puinButton(cid, puin, area = 'puin_head_pic') {
  return getReportProps(
    'puin_button',
    {
      cid,
      actionid: 'click_puin',
      click_type: 'single',
      puin,
      area,
    },
    true,
  );
}
// 编号10点击之后进入搜索结果页
function searchWordButton(cid) {
  return getReportProps(
    'search_word_button',
    {
      cid,
      actionid: 'click_search_word',
      click_type: 'single',
    },
    true,
  );
}

function mrkdCard(cid, busiType, index) {
  return getReportProps('0001300', {
    s_cid: cid,
    s_busi_type: busiType,
    s_order: index,
  });
}

// eslint-disable-next-line import/prefer-default-export
export const universalReport = {
  card,
  likeButton,
  wxShareButton,
  feedbackButton,
  followButton,
  puinButton,
  searchWordButton,
  mrkdCard,
  authorHotContentCard,
  imageVideoCard,
  setPublicAndPrivateParams,
};
